// Legacy Vuex module — metric glyphs moved to FootballMetricIcon + footballMetricIcons.js
export const iconModule = {
    state: () => ({}),
    namespaced: true,
};
